<template>
    <div>
        <el-form :inline="true" :model="searchForm">
            <el-form-item label="ICCID：">
                <el-input v-model.trim="searchForm.iccid" clearable></el-input>
            </el-form-item>
            <el-form-item label="操作时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="供应商名称："> 
                <el-select v-model="searchForm.supplierId" clearable>
                    <el-option v-for="item in supplierOption" :value="item.id" :key="item.id" :label="item.supplierName"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item >
                <el-button type="primary"  @click="getListHandler($event)">搜索查询</el-button>
                <el-button type="success"  @click="exportHandle()">导出Excel</el-button>
            </el-form-item>
        </el-form>


        <el-table :data="tbpg.tableData" border >
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="iccid" label="ICCID" width="170"></el-table-column>
            <el-table-column prop="supplierName" label="供应商" width="120"></el-table-column>
            <el-table-column prop="createTime" label="处理时间" width="150"></el-table-column>
            <el-table-column prop="remark" label="备注" show-overflow-tooltip></el-table-column>
            
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>  

    </div>
</template>
<script>
import common from '@/utils/common.js'
export default {
    data(){         
        return {
            searchForm:{
                iccid: null,
                supplierId: null,
                time: null
            },

            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0                
            },

            supplierOption: []
        }
    },
    methods: {       

        getListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            common.sysRequest('simSupplier/sim/timer', data, 'post').then(res => {
                if(res.data.code == 200){
                    common.listCallback(this, res, 'tbpg');
                }
            })
        },

        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getListHandler();
            
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getListHandler();
            
        },

        exportHandle(){//导出excel文件
            var data = JSON.parse(JSON.stringify(this.searchForm));
            data.token = localStorage.getItem('token');
            data.pageSize = 10000;
            data.prePageNum = 10000;
            if(data.time){
                data.startTimeString = data.time[0] + ' 00:00:00';
                data.endTimeString = data.time[1]+' 23:59:59';
            }
            this.exportExcel('/excels/sim/timer/fail', data);
            this.$message.success('下载中……');
        }
    },
    created () {
        this.getListHandler();
        common.getSupplierOptsCom(this, 'supplierOption')
    },

    computed: {
        
    },

    watch:{

    }
}
</script>


<style lang="scss" scoped>

    .title{
        height: 32px;
        line-height: 32px;
        margin-bottom: 10px;

        span{
            display: inline-block;
            height: 22px;
            width: 5px;
            margin-right: 5px;
            background: #2196f3;
            vertical-align: bottom;
        }
        h1{
            display: inline-block;
            height: 18px;
            line-height: 16px;
            font-size: 14px;
            font-weight: bold;
            width: 300px;
            vertical-align: bottom;
        }
    }
    .export-tamplate{
        box-sizing: border-box;
        border: 1px solid #dcdfe6;
        border-radius: 3px;
        width: 85px;
        height: 32px;
        display: inline-block;
        text-align: center;
        vertical-align: bottom;
        margin-left: 10px;
        font-size: 13px;
        color: #606266;
    }

    .export-tamplate:hover{
        color: #409EFF;
        border-color: #409EFF;
        transition: .3s;
    }
</style>